module.exports = __webpack_public_path__ + "img/caret-right.287f1413.svg";